import { JsonLdResult } from 'src/templates/queries/types';
import { getJsonLdResultLocalName } from 'src/utils/jsonld/getJsonLdResultLocalName';

export const getJsonLdResultValue = (
  result: JsonLdResult[keyof JsonLdResult],
  filter?: (res: string | JsonLdResult, idx: number) => boolean
): string => {
  if (typeof result === 'object') {
    const results: Array<string | JsonLdResult> = Array.isArray(result)
      ? result
      : [result];

    const filtered = filter ? results.filter(filter) : results;

    return filtered
      .map((res) => {
        if (typeof res === 'string') {
          return res;
        }

        if (res['@value'] !== undefined) {
          return res['@value'];
        }

        if (res['@list']) {
          return res['@list']
            .map((val) => getJsonLdResultValue(val, filter))
            .join(', ');
        }

        return getJsonLdResultLocalName(res);
      })
      .join(', ');
  }

  return `${result}`;
};
